import React from 'react';
import Doctors from '../../components/Doctors/Doctors';

const DoctorsDetails = () => {
    return (
        <>
            <Doctors />
        </>
    );
};

export default DoctorsDetails;